"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WarningIcon = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var WarningIcon = function (_a) {
    var color = _a.color;
    return (react_1.default.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("path", { d: "M20.1197 18.2207L12.994 4.86131C12.571 4.06706 11.4325 4.06706 11.0083 4.86131L3.8837 18.2207C3.48433 18.9699 4.0277 19.8756 4.87708 19.8756H19.1275C19.9757 19.8756 20.5191 18.9699 20.1197 18.2207ZM12.0017 17.6256C11.3807 17.6256 10.8767 17.1216 10.8767 16.5006C10.8767 15.8796 11.3807 15.3756 12.0017 15.3756C12.6227 15.3756 13.1267 15.8796 13.1267 16.5006C13.1267 17.1216 12.6227 17.6256 12.0017 17.6256ZM13.1267 14.2506H10.8767V9.75056H13.1267V14.2506Z", fill: color })));
};
exports.WarningIcon = WarningIcon;
//# sourceMappingURL=util.js.map